// src/contexts/RepaymentsContext.js
import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  useCallback,
} from "react";

const initialState = {
  repaymentsContext: [],
  updateRepaymentsContext: () => {},
  clearRepayments: () => {},
};

const RepaymentsContext = createContext(initialState);

const RepaymentsProvider = ({ children }) => {
  const [repaymentsContext, setRepaymentsState] = useState([]);
  
  const updateRepaymentsContext = useCallback((newRepayments) => {    
    setRepaymentsState(newRepayments);
  }, []);

  const clearRepayments = useCallback(() => {
    setRepaymentsState([]);
  }, []);

  const value = useMemo(() => ({
    repaymentsContext,
    updateRepaymentsContext,
    clearRepayments,
  }), [repaymentsContext, updateRepaymentsContext, clearRepayments]);

  return (
    <RepaymentsContext.Provider value={value}>
      {children}
    </RepaymentsContext.Provider>
  );
};

const useRepaymentsContext = () => {
  const context = useContext(RepaymentsContext);
  if (!context) {
    throw new Error("useRepaymentsContext must be used within RepaymentsProvider");
  }
  return context;
};

export { RepaymentsProvider, useRepaymentsContext };
